import React from "react";

const StatusSymbol = ({ status, qaState, nolabel }) => {

  let statusLabel = "", className = "";
  const lineitemState = status.toLowerCase();
  const pendingStates = [
    "launched",
    "awaiting_approval"
  ];
  const pendingQaStates = [
    "pre_approve",
    "pre_approved",
    "post_approved"
  ];
  const approvedStates = [
    "qa_approved",
    "launched",
    "closed",
    "invoiced",
    'paused'
  ];
  
  if (pendingStates.indexOf(lineitemState) > -1 && pendingQaStates.indexOf(qaState.toLowerCase()) > -1) {
    statusLabel = "Pending";
    className = 'icon-minus-circle warning'
  } else if (approvedStates.indexOf(lineitemState) > -1) {
    statusLabel = "Approved";
    className = 'icon-check-circle success'
  } else if (lineitemState === "rejected") {
    statusLabel = "Rejected";
    className = 'icon-slash error'
  }

  return (
    <div className={!nolabel ? "status" : ""}>
      <i className={`axiom-icon-icon ${className}`}/>
      {!nolabel && <span>{statusLabel || lineitemState}</span>}
    </div>
  )
}

StatusSymbol.defaultProps = {
  status: '',
  nolabel: false
}

export default StatusSymbol